import React, {Component, PropTypes} from 'react';
import ReactDOM from 'react-dom';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import Platform from 'platform';
import ClassNames from 'classnames';

import _isEqual from 'lodash/isEqual';
import _get from 'lodash/get';
import _debounce from 'lodash/debounce';

import Translate from '../../../components/Translate';

import {SetBookmark} from '../../../actions/common/actions-common';
import {OpenMessage, CloseMessage} from '../../../actions/common/actions-common';

import {ACTIONS} from '../index';

window.plugin = new youbora.Plugin({ accountCode: 'sotalcloud' });

export const STATES = {
    IDLE: 0, // when player has been created or released
    PREPARING: 1, // when player receives the api command to load the movie until it starts requesting the first fragment
    BUFFERING: 2, // when player doesn't have enough data to play the content for any reasons
    PLAYING: 3, // when player starts playing content
    PAUSED: 4, // when player is stopped
    ENDED: 5, // when video is ended
    ERROR: 6, // when player encounters an error
};

export const SYNC_POSITION_IN_PERCENT = 0.15;

class RMP extends Component {
    videoNode = null;
    constructor(props) {
        super(props);

        this.player = null;
        this.monitoring = null;

        this.state = {
            //state: STATES.IDLE,
            isInit: false,
            isError: false,
            errorMsg: '',
        };

        this.SetBookmark = _debounce(this.props.SetBookmark.bind(this), 1200);
    }

    componentDidMount() {

        this.setState({
            isError: false,
            errorMsg: ''
        });

        this.monitoring = this.props.player.monitoring;

        this.setState({
            player: this.props.player,
        });

        this.__processAction();
    }

    componentWillReceiveProps(newProps) {

        if (!_isEqual(newProps.player, this.props.player)) {
            this.setState({
                isError: false,
                errorMsg: ''
            });

            this.__processAction(newProps);
        }

        if (!_isEqual(newProps.player.monitoring, this.props.player.monitoring)) {
            this.monitoring = newProps.player.monitoring;
        }
    }

    componentWillUnmount() {
        if (this.player) {
            this.player.destroy();
        }
    }

    __processAction(props = this.props) {
        switch (props.player.action) {
            case ACTIONS.OPEN:

                if (this.vliveLogo) {
                    this.vliveLogo.parentNode.removeChild(this.vliveLogo);
                    this.vliveLogo = null;
                }

                if (!this.state.isInit) {

                    this._initPlayer(props.player);
                } else {
                   // this.player.destroy();
                   // this._initPlayer(props.player);
                }

                this.setState({
                    getUrlAgain: props.player.get_url_again_fn
                });

                break;

            case ACTIONS.CLOSE:

                this.Stop();
                break;

            case ACTIONS.RESIZE_DETACHED:

                this.SetSize(props.player.width, props.player.height);

                break;
        }
    }

    Play() {

        return this.player && this.player.play();
    }

    Stop() {

        return this.player && this.player.stop();
    }

    Seek(position) {

        return this.player && this.player.seekTo(position);
    }

    SetSize(width, height) {

         this.player && this.player.setPlayerSize(width || 460, height || 270);
    }

    Ref = (node) => {
        this.videoNode = node;
    };

    _initPlayer(opt) {

        this.setState({isInit: true, isError: false, errorMsg: null});

        var src = {
            hls: opt.stream_url,
        };

        var startPos = _get(this.props.player, 'position', 0);
        if (startPos) {
            startPos *= 1000
        }

        var settings = {
            licenseKey: 'amxtbHpteGphbEAxNTYxMTI5',
            src: src,
            isLive: _get(this.monitoring, 'type', '') === 'channel',
            detectAutoplayCapabilities: true,
            autoplay: true,
            googleCast: false,
            ads: true,
            adParser: 'rmp-vast',
            airplay: false,
            offsetStartPosition: startPos,
        };

        this.player = new RadiantMP('rmpPlayer');
        this.player.init(settings);

        this._bindEvents(this.player, this._handleError, this.props, this.SetBookmark, this.setState);

        if (_get(Config, 'analytics.youbora', true)) {
            plugin.setOptions({
                accountCode: 'sotalcloud',
                enableAnalytics: true,
                username: _get(this.props, 'user.user') || 'Unknown Hamster',
                'content.title': _get(this.monitoring, 'assetTitle', ''),
                'content.isLive': _get(this.monitoring, 'type', '') === 'channel',
                'content.resource': opt.stream_url,
                'content.id':  _get(this.monitoring, 'assetID', ''),
                'content.metadata': {
                    //owner: "provider",
                },
                'device.osName': Platform.name,
                'device.osVersion': Platform.os.version,
                'parse.cdnNodeHost': false,
                httpSecure: true,
                haltOnError: false,
                'extraparam.1': Config.operator_ext_id,
                'content.projectcode': Config.operator_ext_id,
                'content.transactionCode': Config.operator_ext_id,
            });

            plugin.setAdapter(new youbora.adapters.RadiantMP(this.player)); // Attach adapter
        }
    }

    _handleError = (errorData, type) => {

        console.log('rmp ' + type, errorData);
        if (errorData.event.response && errorData.event.response.code === 401) {
            this.props.onLimitReached && this.props.onLimitReached();
            return;
        }
        if (type === 'error') {
            this.setState({isError: true, errorMsg: errorData.event.type});
        }
    };

    _bindEvents(player, handleErrorFn, props, setBookmarkFn) {

        var rmpContainer = document.getElementById('rmpPlayer');

        rmpContainer.addEventListener('error', function() {
            handleErrorFn(player.getErrorData(), 'error');
        });

        var reload =  this._reloadStream;
        rmpContainer.addEventListener('warning', function() {
            handleErrorFn(player.getErrorData(), 'warning');
            // const d = rmp.getErrorData();
            if (d.event && (d.event.details === "bufferStalledError" ||  d.event.details === "bufferNudgeOnStall")) {
                // reload();
            }
        });

        rmpContainer.addEventListener('timeupdate', function(data) {
            const position = player.getCurrentTime();
            const duration = player.getDuration();

            if (_get(Config, 'bookmark_allowed', false) && _get(props.player, 'stream_type', null) === 'vod_hls' && !!_get(props.player, 'asset_id')) {
                if (position % parseInt(duration * SYNC_POSITION_IN_PERCENT, 10) < 100) {
                    setBookmarkFn(_get(props.player, 'asset_id'), parseInt(position/1000, 10));
                }
            }
        });

        rmpContainer.addEventListener('pause', function() {
            const position = player.getCurrentTime();
            if (!!_get(props.player, 'asset_id')) {
                setBookmarkFn(_get(props.player, 'asset_id'), parseInt(position/1000, 10));
            }
        });

        /*
        rmpContainer.addEventListener('playing', function() {
            setStateFn({isError: false, errorMsg: null});
        });*/
    }

    _loadPlaylist(playlist) {
        var newSourceObject = {
            hls: playlist,
        };
        this.player.setSrc(newSourceObject);
    }

    _reloadStream() {
        this.setState({isError: false});

        this.state.getUrlAgain && this.state.getUrlAgain()
            .then((stream_url) => {

                this._loadPlaylist(stream_url);
            }, () => {

                this.setState({isError: true});
            });
    }

    render() {
        const noSignalClass = ClassNames({
            'show': this.state.isError,
            'player-no-signal crow no-gutter': true
        });

        return (<div>
            <div id="player_no_signal" className={noSignalClass}>
                <p className="p no-signal-text"><Translate content="player.no_signal" />
                    <span className="p player-error-text"> {this.state.errorMsg} </span>
                    <span className="mv- pv btn-dark pointer"
                          onClick={this._reloadStream.bind(this)}
                          style={{display: 'block', float: 'none'}} title={Translate.translator('player.reload')}>
                      <i className="ic ic-reload ic-24px"></i>
                    </span>
                </p>
            </div>
            <div id="rmpPlayer"></div>
        </div>);
    }
}

RMP.propTypes = {
    player: PropTypes.object.isRequired,
    onLimitReached: PropTypes.func,
};

const mapStateToProps = ({auth: {user}}) => {
    return {
        user: user,
    };
};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators({SetBookmark, OpenMessage, CloseMessage}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(RMP);



// WEBPACK FOOTER //
// ./src/containers/Player/RadiantMediaPlayer/rmp.js